import { useAuthUsername } from '@akin-home/auth/react';
import { useListStateVariables as useListStateVariableBase } from '@akin-home/state-variables-react';
import { assembleUserChatID } from '@akin-home/user';
import { UseQueryOptions } from 'react-query';
import { useApplicationID } from '../../chat/useAkinChat';
import { useCurrentUserID } from '../../users';

/** Wrapper for the base hook that injects the application_id and user details into the query */
export const useListStateVariables = (
  variable_names: string[],
  options?: UseQueryOptions
) => {
  const id = useCurrentUserID();
  const username = useAuthUsername() || '';

  return useListStateVariableBase(
    {
      application_id: useApplicationID(),
      username: assembleUserChatID(username, id),
      names: variable_names,
    },
    options
  );
};
